import API from '../utils/request'

// 登录
export function login(data) {
    return API({
        url: `/login`,
        data: data,
        method: "post",
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 获取导航栏数组
export function getMenu() {
    return API({
        url: `/system/menu/list`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 发送邮箱验证码
export function sendEmailCode(data) {
    return API({
        url: `/sendEmailCode`,
        data: data,
        method: "post",
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 邮箱注册
export function emailRegister(data) {
    return API({
        url: `/emailRegister`,
        data: data,
        method: "post",
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 忘记密码（邮箱重置）
export function emailResetPassword(data) {
    return API({
        url: `/forgetPassword`,
        data: data,
        method: "post",
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 校验邀请码（仅校验有效性，不做绑定）
export function validateInviteCode(data) {
    return API({
        url: `/invite/validate`,
        data: data,
        method: "post",
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}
